import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SelectAppTableRow from "./SelectAppTableRow";
import useTimeSupervision from "./useTimeSupvervision";
import useLangTranslation from "../../../../customHooks/languageProvider";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import { useDashboardDataProvider } from "../../../../customHooks/dashboardDataProvider";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import { useHistory } from "react-router";
import Select from "react-select";
import useCallsAndSms from "../CallAndSms/useCallsAndSms";

const TimeSupervisionSelectApps = ({ deviceSelected }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [kidData, setKidData] = useState(null);
  const [keyStrokeData, setKeyStrokeData] = useState([]);
  const [keyStrokeContactData, setKeyStrokeContactData] = useState([]);

  const [keyStrokeFormattedData, setKeyStrokeFormattedData] = useState([]);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [callsAndSmsData, setCallsAndSmsData] = useState(null);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFormChanged, setIsFormChanged] = useState(false); // Track if changes are made
  const [activeTab, setActiveTab] = useState("TIME_SUPERVISION_TAB_ALLOWED_APPS"); // Initialize activeTab here

  const { keyStrokesModifiedData, postCollectionData, getTimeSuperVisionData } =
    useTimeSupervision();

  const {
    handleToggleChange,
    handleAllSelect,
    handleCheckBoxChange,
    handleCallsAndSmsStatusChange,
  } = useCallsAndSms(deviceSelected, callsAndSmsData, setCallsAndSmsData);

  const { getImage } = useKidListFunctionality();
  const { getLangTranslation } = useLangTranslation();
  const { handleDeviceSelection } = useDashboardDataProvider();

  const { selectedKidId, kidDevicesList, selectedDeviceData, kidList } =
    useSelector(({ dashboard }) => dashboard);

  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(deviceStatus, setDeviceStatus);

  useEffect(() => {
    if (callsAndSmsData && callsAndSmsData?.contacts?.length > 0) {
      setKeyStrokeContactData([...callsAndSmsData?.contacts]);
      setFilteredContacts([...callsAndSmsData?.contacts]);
    }
  }, [callsAndSmsData?.contacts, activeTab]);

  useEffect(() => {
    if (setRulesData) {
      setKeyStrokeData(setRulesData?.timesupervison?.allowedApps);
      // setKeyStrokeContactData(setRulesData?.callAndSmsMonitoring?.contacts);
      setCallsAndSmsData(setRulesData?.callAndSmsMonitoring || null);
      const data = keyStrokesModifiedData(
        setRulesData?.timesupervison?.allowedApps
      );
      setKeyStrokeFormattedData(data);
    }
  }, [setRulesData]);

  useEffect(() => {
    if (selectedKidId && kidList) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKidData(kid);
    }
  }, [selectedKidId, kidList]);

  useEffect(() => {
    if (selectedDeviceData) {
      getTimeSuperVisionData(selectedDeviceData?.ID);
      getDeviceStatusData(selectedDeviceData?.ID);
      getTimeSuperVisionData(selectedDeviceData?.ID, "UsedAppTimeDataModel");
    } else setDeviceStatus("");
  }, [selectedDeviceData]);

  const handleChange = () => {
    setIsFormChanged(true); // Mark form as changed
  };

  // Function to handle "Select All" for contacts
  const handleSelectAllContacts = (e) => {
    let tempKeyStrokeData = [...filteredContacts];

    // Loop through the contacts and update their monitoring status based on "Select All" checkbox
    tempKeyStrokeData = tempKeyStrokeData.map((item) => {
      const tempObj = { ...item };
      tempObj["callMonitored"] = e.target.checked ? 1 : 0; // Set to 1 for selected, 0 for unselected
      return tempObj;
    });

    // Update the state with the new selected contacts
    setKeyStrokeContactData(tempKeyStrokeData);
    setFilteredContacts(tempKeyStrokeData); // Ensure filtered contacts are also updated
    setIsFormChanged(true); // Mark form as changed when select all checkbox is toggled
  };

  const allSelected = filteredContacts.length > 0 && filteredContacts.every(contact => contact.callMonitored === 1);
  const noneSelected = filteredContacts?.every(contact => contact.callMonitored !== 1);

  function handleAppToggle(e, appUuid) {
    let tempKeyStrokeData = [...keyStrokeData];
    if (e.target.name === "allSelect") {
      tempKeyStrokeData = tempKeyStrokeData?.map((item) => {
        const tempObj = { ...item };
        tempObj["timeAppMonitoringStatus"] = e.target.checked ? 1 : 0;
        return tempObj;
      });
    } else {
      const indexToEdit = tempKeyStrokeData?.findIndex(
        (item) => parseInt(item?.appUuid) === parseInt(appUuid)
      );
      const shallowCopyOfObj = { ...tempKeyStrokeData[indexToEdit] };
      shallowCopyOfObj["timeAppMonitoringStatus"] = e.target.checked ? 1 : 0;
      tempKeyStrokeData.splice(indexToEdit, 1, shallowCopyOfObj);
    }

    setKeyStrokeData(tempKeyStrokeData);
    const data = keyStrokesModifiedData(tempKeyStrokeData);
    setKeyStrokeFormattedData(data);
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  function handleSaveData() {
    setLoader(true);
    const collectionPayload = {
      ...setRulesData?.timesupervison,
      allowedApps: keyStrokeData,
    };
    postCollectionData(selectedDeviceData?.ID, { timesupervison: collectionPayload });
    setTimeout(() => {
      setLoader(false);
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Data saved successfully",
          message: "DATA_SAVED",
        })
      );
    }, 1000);
  }

  function handleSaveContact() {
    const collectionPayload = {
      ...setRulesData?.timesupervison,
      allowedContacts: keyStrokeData,
    };
    postCollectionData(selectedDeviceData?.ID, { timesupervison: collectionPayload });
    setTimeout(() => {
      setLoader(false);
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Data saved successfully",
          message: "DATA_SAVED",
        })
      );
    }, 1000);
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  // Tab management
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5"
                  >
                    <i
                      className={`c-pointer ${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "SCREENSHOTS_SELECT_APPS",
                      "Select apps"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img
                  src={getImage(kidData?.image, kidData?.gender)}
                  alt="icon"
                />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "SCREENSHOT_HISTORY_SELECT_DEVICE_TITLE",
                    "Active device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs for Allowed Apps and Allowed Contacts */}
      <ul className="custom-tab-wrap">
        <li
          className={`custom-tab ${activeTab === "TIME_SUPERVISION_TAB_ALLOWED_APPS" ? "active-tab" : ""}`}
          onClick={() => {
            setActiveTab("TIME_SUPERVISION_TAB_ALLOWED_APPS");
            setIsFormChanged(true); // Mark form as changed when tab is clicked
          }}
        >
          {getLangTranslation("TIME_SUPERVISION_TAB_ALLOWED_APPS", "Allowed Apps")}
        </li>
        <li
          className={`custom-tab ${activeTab === "TIME_SUPERVISION_TAB_ALLOWED_CONTACTS" ? "active-tab" : ""}`}
          onClick={() => {
            setActiveTab("TIME_SUPERVISION_TAB_ALLOWED_CONTACTS");
            setIsFormChanged(true); // Mark form as changed when tab is clicked
          }}
        >
          {getLangTranslation("TIME_SUPERVISION_TAB_ALLOWED_CONTACTS", "Allowed contacts")}
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content">
        {/* Allowed Apps Tab */}
        {activeTab === "TIME_SUPERVISION_TAB_ALLOWED_APPS" && (
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-6">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    disabled={keyStrokeFormattedData?.length === 0}
                    checked={
                      keyStrokeData?.length > 0 &&
                      keyStrokeData?.filter(
                        (item) => item?.timeAppMonitoringStatus !== 1
                      )?.length < 1
                    }
                    name="allSelect"
                    id="selectAll"
                    onChange={(e) => handleAppToggle(e)}
                  />
                  <label className="form-check-label text-dark" htmlFor="selectAll">
                    {getLangTranslation(
                      "MANAGE_NOTIFICATION_SELECT_ALL",
                      "Select All"
                    )}
                  </label>
                </div>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleSaveData}
                  disabled={!isFormChanged} // Disable Save button if no changes are made
                >
                  <span className="btn-upper-case">
                    {getLangTranslation("SAVE", "Save")}
                  </span>
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped ">
                  <tbody>
                    {keyStrokeFormattedData?.map((item, index) => {
                      return (
                        <SelectAppTableRow
                          appItem={item}
                          key={index}
                          handleAppToggle={handleAppToggle}
                        />
                      );
                    })}
                  </tbody>
                </table>
                {
                  keyStrokeFormattedData?.length === 0 && (
                    <div className="text-center my-2">
                      --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )}

        {/* Allowed Contacts Tab */}
        {activeTab === "TIME_SUPERVISION_TAB_ALLOWED_CONTACTS" && (
          <div className="card">
            <div className="card-body">
              <div className="text-center my-2">
                <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="SELECT_ALL"
                      name="SELECT_ALL"
                      checked={allSelected} // Check if all contacts are selected
                      onChange={handleSelectAllContacts}
                    />
                    <label className="form-check-label text-dark" htmlFor="SELECT_ALL">
                      {getLangTranslation("CONTACTS_TO_MONITOR_SELECT_ALL", "Select All")}
                    </label>
                  </div>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleSaveContact}
                    disabled={loader || filteredContacts?.length === 0}
                  >
                    <span className="btn-upper-case">
                      {getLangTranslation("SAVE", "Save")}
                    </span>
                  </button>
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th className="v-middle">
                          <div className="form-check">
                            <label className="form-check-label mt-1" htmlFor="name">
                              {getLangTranslation("ADD_CHILD_NAME", "Name")}
                            </label>
                          </div>
                        </th>
                        <th className="v-middle">
                          {getLangTranslation("PHONE_NUMBER", "Phone number")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {keyStrokeContactData?.map((item) => (
                        <tr key={item?.contactID}>
                          <td className="v-middle">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="SINGLE_SELECT"
                                id={item?.contactID}
                                checked={item?.callMonitored}
                                onChange={(e) => {
                                  handleCheckBoxChange(e, activeTab);
                                  setIsFormChanged(true); // Mark as changed when checkbox is toggled
                                }}
                              />
                              <label className="form-check-label" htmlFor="name">
                                {item?.name}
                              </label>
                            </div>
                          </td>
                          <td className="v-middle">{item?.number}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {keyStrokeContactData?.length === 0 && (
                    <div className="text-center my-3">
                      --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default TimeSupervisionSelectApps;

